import { Store } from 'pullstate'

export const AuthStore = new Store({
  memberId: null,
  memberName: '',
  viewList: []
})
